

import { createBrowserRouter } from "react-router-dom";


import DashboardLayout from "./layout/Dashboard";
import Dashboard from "./pages/Dashboard";
import Root from "./layout/Root";
import Login from "./pages/auth/Login";
import OrderDetail from "./pages/OrderDetail";
import ManageStaff from "./pages/ManageStaff";
import StaffDetails from "./pages/ManageStaff/StaffDetails";
import Notifications from "./pages/Notifications";
import Settings from "./pages/Settings";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/Customers/CustomerDetail";
import GroupAdd from "./pages/Product/Group/add";
import GroupEdit from "./pages/Product/Group/edit";
import GroupMasterAdd from "./pages/Product/GroupMaster/add";
import GroupMaster from "./pages/Product/GroupMaster";
import GroupMasterEdit from "./pages/Product/GroupMaster/edit";


import SubGroupAdd from "./pages/Product/SubGroup/add";
import SubGroup from "./pages/Product/SubGroup";
import SubGroupEdit from "./pages/Product/SubGroup/edit";



import SubSubGroupAdd from "./pages/Product/SubSubGroup/add";
import SubSubGroup from "./pages/Product/SubSubGroup";
import SubSubGroupEdit from "./pages/Product/SubSubGroup/edit";

import ProductMasterAdd from "./pages/Product/ProductMaster/add";
import ProductMaster from "./pages/Product/ProductMaster";
import ProductMasterEdit from "./pages/Product/ProductMaster/edit";

import CategoryAdd from "./pages/Product/Category/add";
import Category from "./pages/Product/Category";
import CategoryEdit from "./pages/Product/Category/edit";

import SubCategoryAdd from "./pages/Product/SubCategory/add";
import SubCategory from "./pages/Product/SubCategory";
import SubCategoryEdit from "./pages/Product/SubCategory/edit";

import CollectionAdd from "./pages/Product/Collection/add";
import Collection from "./pages/Product/Collection";
import CollectionEdit from "./pages/Product/Collection/edit";


import ShapeSizeAdd from "./pages/Product/ShapeSize/add";
import ShapeSize from "./pages/Product/ShapeSize";
import ShapeSizeEdit from "./pages/Product/ShapeSize/edit";
import Product from "./pages/OrderDetail/Product";
import Catalog from "./pages/Catalog";
import CatalogProduct from "./pages/Catalog/CatalogProduct";
import AllChat from "./pages/AllChat";
import ProductGroup from "./pages/ProductGroup";
import SubmittedProduct from "./pages/OrderDetail/SubmiitedOrder";
import ErrorPage from "./pages/ErrorPage";
import CenteredLayout from "./layout/CenteredLayout";
import AllDiscussion from "./pages/AllDiscussion";
import HelpCenter from "./pages/HelpCenter";
import OrderTags from "./pages/OrderTags";
import TrackOrder from "./pages/TrackOrder";

export const router = createBrowserRouter([

    {
        path: '/',
        element: <Root />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '',
                element: <DashboardLayout />,
                children: [
                    {
                        path: '',
                        element: <Dashboard />
                    },
                    {
                        // Standard centered content width; excludes the Kanban dashboard above.
                        element: <CenteredLayout />,
                        children: [
                    {
                        path: '/order/:id/:orderRef/:customer_id',
                        element: <OrderDetail />,
                    },
                    {
                        path: '/manage-staff',
                        element: <ManageStaff />,
                    },
                    {
                        path: '/manage-staff/:staffId',
                        element: <StaffDetails />,
                    },
                    {
                        path: '/allchat',
                        element: <AllChat />,
                    },
                    {
                        path: '/alldiscussion',
                        element: <AllDiscussion />,
                    },
                    {
                        path: '/notifications',
                        element: <Notifications />,
                    },
                    {
                        path: '/settings',
                        element: <Settings />,
                    },
                    {
                        path: '/order-tags',
                        element: <OrderTags />,
                    },
                    {
                        path: '/track-order',
                        element: <TrackOrder />,
                    },
                    {
                        path: '/customers',
                        element: <Customers />,
                    },
                    {
                        path: '/customers/:id',
                        element: <CustomerDetail />,
                    },
                    {
                        path: '/customers/:id',
                        element: <CustomerDetail />,
                    },
                    { path: '/product_group', element: <ProductGroup /> },

                    { path: '/group', element: <GroupAdd /> },
                    { path: '/group/add', element: <GroupAdd /> },
                    { path: '/group/edit/:id', element: <GroupEdit /> },

                    { path: '/group_masters', element: <GroupMaster /> },
                    { path: '/group_masters/add', element: <GroupMasterAdd /> },
                    { path: '/group_masters/edit/:id', element: <GroupMasterEdit /> },

                    { path: '/sub-group', element: <SubGroup /> },
                    { path: '/sub-group/add', element: <SubGroupAdd /> },
                    { path: '/sub-group/edit/:id', element: <SubGroupEdit /> },

                    { path: '/sub-sub-group', element: <SubSubGroup /> },
                    { path: '/sub-sub-group/add', element: <SubSubGroupAdd /> },
                    { path: '/sub-sub-group/edit/:id', element: <SubSubGroupEdit /> },

                    { path: '/product-master', element: <ProductMaster /> },
                    { path: '/product-master/add', element: <ProductMasterAdd /> },
                    { path: '/product-master/edit/:id', element: <ProductMasterEdit /> },

                    // Category
                    { path: '/category', element: <Category /> },
                    { path: '/category/add', element: <CategoryAdd /> },
                    { path: '/category/edit/:id', element: <CategoryEdit /> },

                    // Sub Category
                    { path: '/sub-category', element: <SubCategory /> },
                    { path: '/sub-category/add', element: <SubCategoryAdd /> },
                    { path: '/sub-category/edit/:id', element: <SubCategoryEdit /> },

                    // Collection
                    { path: '/collection', element: <Collection /> },
                    { path: '/collection/add', element: <CollectionAdd /> },
                    { path: '/collection/edit/:id', element: <CollectionEdit /> },

                    // Shape Size
                    { path: '/shape-size', element: <ShapeSize /> },
                    { path: '/shape-size/add', element: <ShapeSizeAdd /> },
                    { path: '/shape-size/edit/:id', element: <ShapeSizeEdit /> },
                    {
                        path: '/product-view/:id', element: <Product />
                    },
                    {
                        path: '/catalog',
                        element: <Catalog />,
                    },
                    {
                        path: '/catalog-product/:type',
                        element: <CatalogProduct />,
                    },
                    {
                        path: '/help-center',
                        element: <HelpCenter />,
                    },
                    {
                        path: '/submitted-order/:id', element: <SubmittedProduct />
                    }
                        ]
                    }

                ],
                errorElement: <ErrorPage />
            },

        ]
    },
    {
        path: '/login',
        element: <Login />,
        errorElement: <ErrorPage />
    }
])